export default function getQueryString(name: string) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i'); // 匹配目标参数
  const result = window.location.search.substr(1).match(reg);  // 对querystring匹配目标参数

  if (result !== null) {
    try {
      return decodeURI(result[2]);
    } catch (err) {
      console.log('URI编解码异常');
      return Reflect.get(window, name.toLocaleUpperCase());
    }
  } else {
    return null;
  }
}